import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false
}

export const validate = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.FETCH_VALIDATE_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_VALIDATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_VALIDATE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.CLEAR_VALIDATE_DATA:
      return {
        ...state,
        data: {}
      }
    default:
      return state;
  }
}
